import { render } from "./BusinessDetails.vue?vue&type=template&id=a2676f1c&scoped=true"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"

import "./BusinessDetails.vue?vue&type=style&index=0&id=a2676f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2676f1c"]])

export default __exports__